import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { V3_GROUP_ORDER_BASE_PATH } from './group-order-app-path';
import { GroupOrderFatalErrorService } from './group-order-fatal-error.service';

function isV3StorefrontPath(url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  return path === V3_GROUP_ORDER_BASE_PATH || path.startsWith(`${V3_GROUP_ORDER_BASE_PATH}/`);
}

/**
 * App-wide handler that maps uncaught errors on `/store` routes to the storefront fatal UI
 * (instead of a blank screen from a broken template or change detection).
 */
@Injectable()
export class GroupOrderErrorHandler implements ErrorHandler {
  private readonly router = inject(Router);
  private readonly fatal = inject(GroupOrderFatalErrorService);

  handleError(error: unknown): void {
    try {
      const url = this.router.url ?? '';
      if (isV3StorefrontPath(url)) {
        this.fatal.reportFatalError();
      }
    } catch {
      /* ignore secondary failures */
    }
    console.error(error);
  }
}
